import './frontend.scss';

// Utilizes "modal-menu" module
